/**
 * @generated SignedSource<<06d47f16b8a59b351a80264edcebd254>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionFragmentMaxProductsRefetchQuery$variables = Record<PropertyKey, never>;
export type SubscriptionFragmentMaxProductsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"productList_subscriptionFragmentMaxProducts">;
};
export type SubscriptionFragmentMaxProductsRefetchQuery = {
  response: SubscriptionFragmentMaxProductsRefetchQuery$data;
  variables: SubscriptionFragmentMaxProductsRefetchQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionFragmentMaxProductsRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "productList_subscriptionFragmentMaxProducts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscriptionFragmentMaxProductsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "areSalesChannelsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MaxProducts",
            "kind": "LinkedField",
            "name": "maxProducts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canAddProduct",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxProducts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numProducts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numPublishedProducts",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c964c547d7197d5a72001e26f7f89331",
    "id": null,
    "metadata": {},
    "name": "SubscriptionFragmentMaxProductsRefetchQuery",
    "operationKind": "query",
    "text": "query SubscriptionFragmentMaxProductsRefetchQuery {\n  ...productList_subscriptionFragmentMaxProducts\n}\n\nfragment productList_subscriptionFragmentMaxProducts on Query {\n  subscription {\n    id\n    areSalesChannelsEnabled\n    maxProducts {\n      pricingVersion\n      canAddProduct\n      maxProducts\n      numProducts\n      numPublishedProducts\n    }\n  }\n}\n"
  }
};

(node as any).hash = "8aa91cde9d18f36210baf753ba0bbd70";

export default node;
